module.exports = __webpack_public_path__ + "static/media/ClubChat.2413dde1.png";